export const RiskLiquidity = {
  MonitoringLiquidity: {
    Data: {}
  },

  SocialMediaMentions: {
    Data: {}
  },

  MarketPriceAction: {
    Data: {}
  },

  BankFailures: {
    CityStateOptions: {
      Data: {}
    },
    YearOptions: {
      Data: {}
    },
    ListOfUSBankFailures: {
      Data: {}
    },
    UsBankFailures: {
      Data: {}
    }
  },
  BankRunBenchmarking: {
    Data: {}
  },

  CrisisScenario: {
    Data            : {},
    SelectedScenario: 'Panic'
  },

  DepositBehavior: {
    TotalItems : 0,
    CurrentPage: 1,
    Data       : {},
    Assumptions: null
  },

  BankReadiness: {
    TotalItems : 0,
    CurrentPage: 1,
    Data       : {}
  }
}
